/* eslint-disable jsx-a11y/iframe-has-title */
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import Paper from '@mui/material/Paper';
import { toast } from 'react-toastify';
import FileSaver from 'file-saver';
import axios from 'axios';


function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: 'id', numeric: false, label: 'Id' },
  { id: 'name', numeric: true, label: 'Name' },
  { id: 'file', numeric: true, label: 'Download' },
  { id: 'deactivate', numeric: true, label: 'Deactivate' },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.id} align='left' sortDirection={orderBy === headCell.id ? order : false} >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function FilesTable({id, get, data, setDeleting, isAdmin}) {
  
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState('asc');
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [orderBy, setOrderBy] = React.useState('calories');


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onDownload = (idx, name) => {
    
      fetch(`${process.env.REACT_APP_URL}/api/idp/v2/project/${id}/pc/${idx}`, {
        headers: { 
          Authorization: sessionStorage.getItem('token'),
       },
      }).then((res) => res.blob())
        .then((blob) => {
            console.log(name)
            FileSaver.saveAs(blob, `${name}.json`)
        }).catch((err) => {
          console.log(err)
          toast.error("An Error occurred!");
        });
  };

  const deleteHandle = (idx)=>{
    setDeleting(idx);
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750, px: 2 }} aria-labelledby="tableTitle" size='medium'>
            <EnhancedTableHead
              order={order} orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={data.length}
            />
            <TableBody>
              {stableSort(data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                  <TableRow hover tabIndex={-1} key={row.id}>
                    <TableCell align="left">{row.id}</TableCell>
                    <TableCell align="left">{row.name}</TableCell>
                    <TableCell align="left">
                      <button onClick={(e) => onDownload(row.id, row.name)} style={{padding: "4px 10px"}} className="border border-blue-200 bg-blue-100 text-blue-700 text-xs cursor-pointer rounded-full hover:text-blue-800 focus:ring-2 focus:outline-none focus:ring-blue-300">
                        download<i className="fa-solid fa-download ml-2"></i>
                      </button>
                    </TableCell>
                    <TableCell align="left">
                      {isAdmin ? 
                      <button onClick={(e) => deleteHandle(row.id)} style={{padding: "4px 10px"}} className="border border-pink-200 bg-pink-100 text-pink-700 text-xs cursor-pointer rounded-full hover:text-pink-800 focus:ring-2 focus:outline-none focus:ring-red-300">
                        delete<i className="fa-solid fa-trash ml-2"></i>
                      </button>
                      : "admin only"}
                    </TableCell>
                  </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]} component="div"
          count={data.length} rowsPerPage={rowsPerPage}
          page={page} onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}